import React from 'react';
import G from "../../libs/Glob.mjs";
import AthenaLogo from "../../media/images/AthenaLogo.mjs";
import "./AppHeader.css";
import HamburgerArea from "../../controls/HamburgerArea.mjs";
import UserIcon from "../../media/images/UserIcon.mjs";
import appLib from "../../libs/appLib.mjs";
import LockOffIcon from "../../media/images/LockOffIcon.mjs";
import LanguageSwitcher from "../../controls/LanguageSwitcher.mjs";

const prefix="AppHeader";

const AppHeader = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: G.getUserLoginName(),
			pageTitle: G.getStatus('pageTitle') || window.document.title.split(' :: ').shift(),
		};
		this.uid = G.generateUid(prefix);
		this.renderLogin = this.renderLogin.bind(this);
	}
	componentDidMount() {
		G.register('pageTitle', (x)=>{
			this.setState({ pageTitle: x || window.document.title.split(' :: ').shift() }, ()=>{
				window.document.title = window.document.title.replace(/ :: .+$/,'') + (x ? ' :: '+ x : '');
			});
		}, this.uid);
		G.register('pageButtons', b => {
			this.setState({buttons: b })
		}, this.uid);
		G.register('userLogin', () => {
			this.setState({user: G.getUserLoginName() });
		} , this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	renderLogin() {
		if ( ! this.state.user ) return '';
		return(
			<HamburgerArea
				icon={ <UserIcon /> }
				align={"end"}
			>
				<div className={"UserMenu"}>
					<LanguageSwitcher/>
					<hr/>
					<p>
						<span><b>{this.state.user}</b></span>
						<UserIcon/>
					</p>
					<button onClick={appLib.logout}>
						<b>Logout</b>
						<LockOffIcon/>
					</button>
				</div>
			</HamburgerArea>
		);
	}

	render() {
		return (
			<div className={prefix} id={this.uid}>
				<AthenaLogo />
				<div className={"PageTitle"}>
					<h4>
						{this.state.pageTitle}
					</h4>
				</div>
				{this.state.buttons || this.renderLogin()}
			</div>
		)
	}
}

export default AppHeader;
